import React, { useEffect, useState } from 'react';  
import styles from '../../Routes.module.css';  
import layout from '../../../Modules/layout.module.css';  
import { AreaDisplayInfo } from '../../../Types/AreaDisplayInfo/AreaDisplayInfo';  
import { Route, Routes, useNavigate } from 'react-router-dom';  
import { GetPagedQuestionnaireTemplates, CreateQuestionnaireTemplateByTitle, GetPagedArchivedQuestionnaireTemplates } from '../../../API/TemplateBank/TemplateBank';  
import CreationBar from '../../../Components/Utils/Actions/CreationBar/CreationBar';  
import PagedCardCollection from '../../../Components/Utils/LandingPages/Evaluate/PagedCardCollection';  
import { PagedRequest } from '../../../Types/Paging/PagedRequest';  
import { PagedResponse } from '../../../Types/Paging/PagedResponse';  
import SearchBar from '../../../Components/SearchBar/SearchBar';  
import { ITab } from '../../../Types/ITab';
import TabbedView from '../../../Components/Utils/TabbedView/TabbedView';
import EvaluateActive from '../../Evaluate/EvaluateActive';
import EvaluateArchive from '../../Evaluate/EvaluateArchive';
import EvaluatePlanned from '../../Evaluate/EvaluatePlanned';
import TemplateBankItems from './TemplateBankItems';
import {useAppSelector} from "../../../Redux/Store/Store";
import {getClient} from "../../../Redux/Store/Slices/client";

const TemplateBank = () => {  
  
  return (  
    <div className={styles.container}>  
      <div className={styles.header}>  
        <h3>Template Bank</h3>  
      </div>  
      <div className={styles.body}>  
        <div className={layout.column2}>  
          <Routes>
            <Route path="active" element={<><TemplateBankItems/></>} />
            <Route path="archive" element={<div><TemplateBankItems/></div>} />
          </Routes>
        </div>  
      </div>  
    </div>  
  );  
};  
  
export default TemplateBank;  